import React from "react";
import { useSelector, RootStateOrAny, useDispatch } from "react-redux";
import { Panel } from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";
import { toggleSyncOrderPanel } from "../../../config/redux/orders/ordersPanel/orderPanelActions";
import SyncOptimaForm from "./forms/SyncOptimaForm";
import { panelS } from "../../common/styles/panelStyles";

const OrderOptimaPanel: React.SFC = () => {
  const { t } = useTranslation("admin");
  const dispatch = useDispatch();
  const { syncOrderPanelOpen } = useSelector(
    (state: RootStateOrAny) => state.orderPanel
  );
  const dissmisPanel = () => {
    dispatch(toggleSyncOrderPanel(false));
  };

  return (
    <Panel
      headerText={t("nav.panelSyncOptima") as string}
      isOpen={syncOrderPanelOpen}
      closeButtonAriaLabel={t("nav.close") as string}
      type={1}
      onDismiss={dissmisPanel}
      isLightDismiss={false}
      isHiddenOnDismiss={false}
      styles={panelS}
    >
      <SyncOptimaForm />
    </Panel>
  );
};

export default OrderOptimaPanel;